import React from 'react';
import { motion } from 'framer-motion';

const ease = [0.76, 0, 0.24, 1];

/*
  Curtain page transition: two panels sweep up to reveal the new page, and sweep in
  to cover the old one. Each layer has its own initial/animate/exit (no inherited
  variants) so the content can never get stuck invisible.
*/
export default function PageTransition({ children }) {
  return (
    <main className="page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0, transition: { duration: 0.45, delay: 0.08, ease: [0.22, 1, 0.36, 1] } }}
        exit={{ opacity: 0, y: -20, transition: { duration: 0.28, ease } }}>
        {children}
      </motion.div>
      <motion.div className="curtain curtain-a" aria-hidden="true" style={{ originY: 0 }}
        initial={{ scaleY: 1 }} animate={{ scaleY: 0, transition: { duration: 0.45, ease, delay: 0.04 } }}
        exit={{ scaleY: 1, originY: 1, transition: { duration: 0.3, ease } }} />
      <motion.div className="curtain curtain-b" aria-hidden="true" style={{ originY: 0 }}
        initial={{ scaleY: 1 }} animate={{ scaleY: 0, transition: { duration: 0.45, ease } }}
        exit={{ scaleY: 1, originY: 1, transition: { duration: 0.3, ease, delay: 0.03 } }} />
    </main>
  );
}
